module.exports = __webpack_public_path__ + "static/media/logo_google.fff5178e.png";